export const painPoints: string[] = [
  'Audios y mensajes sin revisar que se acumulan.',
  'Capturas y publicaciones guardadas por todos lados que después no encontrás.',
  'Búsquedas constantes que terminan dejándote con más cosas para revisar.',
  'La sensación de que algo importante se te puede estar escapando entre tanta información.',
  'Una mente cansada de intentar recordar, revisar y estar pendiente de todo.',
]

export const costs: string[] = [
  'Otro mes viviendo saturada',
  'Información que nunca llega a procesarse',
  'Mensajes que generan culpa por no leer',
  'Sensación de estar olvidando algo importante',
  'Cansancio mental sin resolución',
]

export interface Faq {
  question: string
  answer: string
}

export const faqs: Faq[] = [
  {
    question: '¿Necesito ser experta en organización?',
    answer: 'No. Es un sistema simple y práctico, paso a paso.',
  },
  {
    question: '¿Cuánto tiempo me toma?',
    answer:
      'Solo unos minutos por día durante 14 días. No necesitás pasar horas organizando.',
  },
  {
    question: '¿Cuándo empiezo a notar la diferencia?',
    answer: 'Desde el primer día podés empezar a capturar y ordenar la información.',
  },
  {
    question: '¿Con qué tipo de información puedo usarlo?',
    answer: 'WhatsApp, grupos, videos, artículos, audios, publicaciones y búsquedas.',
  },
  {
    question: '¿Qué incluye la garantía?',
    answer: 'Tenés 14 días para probarlo. Si no es para vos, te devolvemos el 100%.',
  },
  {
    question: '¿Es 100% digital?',
    answer:
      'Sí. Recibís todo en PDF para usar desde el celular, tablet, computadora o imprimir.',
  },
  {
    question: '¿Esto me da información médica sobre la epilepsia?',
    answer:
      'No. Te enseña a organizar la información. Las decisiones médicas corresponden al equipo médico.',
  },
]

export const stats: Array<[string, string]> = [
  ['+380', 'madres usando el sistema'],
  ['3', 'volúmenes completos'],
  ['5', 'bonos incluidos'],
  ['4.9/5', 'calificación'],
]
